import React from 'react'
// import './specials.scss'
import AutoMenu from '../../react/AutoMenu'
import {Link} from 'react-router-dom'
export default function () {
  return(
    <div className="custom-page">
      <div className="top-banner" style={{
        backgroundImage: "url(https://d2abh92eaqfsaa.cloudfront.net/image/fetch/c_fill,w_1200/https://dl.airtable.com/MxH1Ew3WQiSfgs6AvoQX_IMG_0477.jpg)"
      }}>
        <h1>Altadena Location</h1>
      </div>

      {/* <AutoMenu categorysToShow={['zoEn0IfzpgPiLMaqqqTq']} /> */}

    </div>
  )
}
